<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

        <v-nav-menu :navMenuItems="navMenuItems" parent=".layout--main"/>

        <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
            <div id="content-overlay"/>
            <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
                <the-navbar-horizontal :navbarType="navbarType" :class="[
                  {'text-white' : isNavbarDark  && !isThemeDark},
                  {'text-base'  : !isNavbarDark && isThemeDark}
                ]" :navMenuItems="navMenuItems" :isNavbarDark="isNavbarDark" :isThemeDark="isThemeDark"/>

                <div style="height: 62px" v-if="navbarType === 'static'"></div>

<!--                <h-nav-menu :class="[-->
<!--                  {'text-white' : isNavbarDark  && !isThemeDark},-->
<!--                  {'text-base'  : !isNavbarDark && isThemeDark}-->
<!--                ]" :navMenuItems="navMenuItems"/>-->
            </template>
            <template v-else>
                <the-navbar-vertical :navbarColor="navbarColor" :class="[
                  {'text-white' : isNavbarDark  && !isThemeDark},
                  {'text-base'  : !isNavbarDark && isThemeDark}
                ]"/>
            </template>
            <!-- /Navbar -->
            <div class="content-wrapper">
                <div class="router-view">
                    <div class="router-content">

<!--                        <vs-popup id="popup-call" class="holamundo" :active.sync="isShowScreen">
                            <div class="rounded">
                                <div class="call-screen">
                                    <div class="vx-row">
                                        <div class="vx-col w-full flex justify-between py-6 px-20">
                                            <div class="text-center text-white">
                                                <div class="avatar_user">
                                                    <vs-avatar class="flex-grow" size="70px"
                                                               :src="isIncomingCall ? receiversImage : userInfo.img"
                                                               alt=""/>
                                                </div>
                                                <span class="text-lg" v-if="!isIncomingCall">Bạn</span>
                                                <span class="text-lg" v-else>
                                                    {{ receiversInfo ? receiversInfo.fullName : 'Không xác định' }}
                                                </span>
                                            </div>
                                            <div class="flex items-center">
                                                <svg width="69" height="36" viewBox="0 0 69 36" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 2L18 18L2 34" stroke="white" stroke-width="4"/>
                                                    <path d="M18 2L34 18L18 34" stroke="white" stroke-opacity="0.75"
                                                          stroke-width="4"/>
                                                    <path d="M34 2L50 18L34 34" stroke="white" stroke-opacity="0.5"
                                                          stroke-width="4"/>
                                                    <path d="M50 2L66 18L50 34" stroke="white" stroke-opacity="0.25"
                                                          stroke-width="4"/>
                                                </svg>
                                            </div>
                                            <div class="text-center text-white">
                                                <div>
                                                    <vs-avatar class="flex-grow" size="70px"
                                                               :src="isIncomingCall ? userInfo.img : receiversImage"
                                                               alt=""/>
                                                </div>
                                                <span class="text-lg" v-if="!isIncomingCall">
                                                    {{ receiversInfo ? receiversInfo.fullName : 'Không xác định' }}
                                                </span>
                                                <span class="text-lg" v-else>Bạn</span>
                                            </div>
                                        </div>
                                        <div class="vx-col w-full text-center text-white">
                                            <span class="" v-if="statusCall === 1">Đang đổ chuông</span>
                                            <span class="" v-if="statusCall === 2">Cuộc gọi bị hủy</span>
                                            <span class="" v-if="statusCall === 3">Đang gọi</span>
                                            <span class="" v-if="statusCall === 4">Kết thúc</span>
                                        </div>
                                        <div class="vx-col w-full text-center">
                                            <span class="text-success" v-if="statusCall === 3">{{ timeString }}</span>
                                            <span class="text-success blinking-text"
                                                  v-if="statusCall === 4">{{ timeString }}</span>
                                        </div>
                                        <div class="vx-col w-full flex justify-center my-4 gap-6">
                                            <div
                                                class="button-method-accept-call flex items-center justify-center cursor-pointer"
                                                v-if="statusCall === 1 && isIncomingCall" @click="acceptCall">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                                     viewBox="0 0 24 24" fill="none" style="transform: rotate(135deg)">
                                                    <g id="style=fill">
                                                        <g id="call">
                                                            <path id="vector"
                                                                  d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.6258 19.6195 21.5163 19.8128 21.388 20C21.3433 20.0651 21.2964 20.1295 21.2471 20.1931C21.1824 20.2767 21.1134 20.359 21.04 20.44C20.8504 20.6489 20.6534 20.8354 20.4476 21C20.1217 21.2608 19.774 21.4667 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                                                                  fill="rgba(var(--vs-success),1)"/>
                                                            <path id="vector (Stroke)" fill-rule="evenodd"
                                                                  clip-rule="evenodd"
                                                                  d="M2.98958 2.39989C3.74153 1.66198 4.62059 1.25 5.59 1.25C5.97318 1.25 6.36311 1.33138 6.71941 1.5014C7.08755 1.67229 7.42309 1.93393 7.68396 2.30922L10.0003 5.574C10.2053 5.85906 10.3657 6.13796 10.4818 6.42035C10.5997 6.6971 10.68 7.00644 10.68 7.32C10.68 7.70687 10.5673 8.07663 10.367 8.40939C10.1968 8.70784 9.96427 8.99567 9.69563 9.26502L9.00688 9.98096C9.01385 9.99743 9.02321 10.0197 9.03333 10.0455C9.183 10.3079 9.44802 10.6772 9.84989 11.1524C10.29 11.6609 10.7568 12.1761 11.2604 12.6897C11.7923 13.2116 12.2961 13.6858 12.8048 14.1178C13.2858 14.5247 13.6606 14.7841 13.933 14.9322C13.955 14.9417 13.9753 14.9509 13.9918 14.9584L14.6815 14.2778C14.955 14.0046 15.2482 13.7638 15.5612 13.5966C15.8882 13.4019 16.2447 13.29 16.64 13.29C16.9399 13.29 17.2362 13.354 17.534 13.4758C17.8169 13.5916 18.0939 13.7509 18.3717 13.9398L18.378 13.9441L21.6909 16.2961C22.0455 16.5425 22.3234 16.8545 22.4965 17.2479L22.5016 17.2596L22.5064 17.2715C22.6338 17.59 22.72 17.9351 22.72 18.33C22.72 18.8025 22.6147 19.2817 22.3982 19.7403C22.2879 19.9738 22.1587 20.2021 22.0066 20.424C21.9538 20.5011 21.8983 20.5773 21.84 20.6525C21.7634 20.7514 21.682 20.8484 21.5957 20.9436C21.3815 21.1797 21.1554 21.3943 20.9162 21.5856C20.537 21.8891 20.1283 22.1318 19.6865 22.3131C18.9922 22.6021 18.2445 22.75 17.45 22.75C16.3114 22.75 15.1213 22.4821 13.896 21.96C12.6885 21.4455 11.4895 20.7561 10.3086 19.8963L10.3076 19.8956C9.12671 19.0331 8.00824 18.0786 6.94224 17.0229L6.93709 17.0178C5.88147 15.9519 4.92677 14.8332 4.07368 13.6614L4.07114 13.658C3.22474 12.4813 2.5351 11.293 2.0297 10.1032L2.02877 10.101C1.51719 8.88605 1.25 7.69701 1.25 6.54C1.25 5.77184 1.3856 5.02732 1.66286 4.33342C1.94487 3.61753 2.38783 2.96904 2.98958 2.39989Z"
                                                                  fill="rgba(var(--vs-success),1)"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div
                                                class="button-method-cancel-call flex items-center justify-center cursor-pointer"
                                                v-if="statusCall === 1 || statusCall === 3" @click="cancelCall">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                                     viewBox="0 0 24 24" fill="none" style="transform: rotate(135deg)">
                                                    <g id="style=fill">
                                                        <g id="call">
                                                            <path id="vector"
                                                                  d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.6258 19.6195 21.5163 19.8128 21.388 20C21.3433 20.0651 21.2964 20.1295 21.2471 20.1931C21.1824 20.2767 21.1134 20.359 21.04 20.44C20.8504 20.6489 20.6534 20.8354 20.4476 21C20.1217 21.2608 19.774 21.4667 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                                                                  fill="rgba(var(--vs-danger),1)"/>
                                                            <path id="vector (Stroke)" fill-rule="evenodd"
                                                                  clip-rule="evenodd"
                                                                  d="M2.98958 2.39989C3.74153 1.66198 4.62059 1.25 5.59 1.25C5.97318 1.25 6.36311 1.33138 6.71941 1.5014C7.08755 1.67229 7.42309 1.93393 7.68396 2.30922L10.0003 5.574C10.2053 5.85906 10.3657 6.13796 10.4818 6.42035C10.5997 6.6971 10.68 7.00644 10.68 7.32C10.68 7.70687 10.5673 8.07663 10.367 8.40939C10.1968 8.70784 9.96427 8.99567 9.69563 9.26502L9.00688 9.98096C9.01385 9.99743 9.02321 10.0197 9.03333 10.0455C9.183 10.3079 9.44802 10.6772 9.84989 11.1524C10.29 11.6609 10.7568 12.1761 11.2604 12.6897C11.7923 13.2116 12.2961 13.6858 12.8048 14.1178C13.2858 14.5247 13.6606 14.7841 13.933 14.9322C13.955 14.9417 13.9753 14.9509 13.9918 14.9584L14.6815 14.2778C14.955 14.0046 15.2482 13.7638 15.5612 13.5966C15.8882 13.4019 16.2447 13.29 16.64 13.29C16.9399 13.29 17.2362 13.354 17.534 13.4758C17.8169 13.5916 18.0939 13.7509 18.3717 13.9398L18.378 13.9441L21.6909 16.2961C22.0455 16.5425 22.3234 16.8545 22.4965 17.2479L22.5016 17.2596L22.5064 17.2715C22.6338 17.59 22.72 17.9351 22.72 18.33C22.72 18.8025 22.6147 19.2817 22.3982 19.7403C22.2879 19.9738 22.1587 20.2021 22.0066 20.424C21.9538 20.5011 21.8983 20.5773 21.84 20.6525C21.7634 20.7514 21.682 20.8484 21.5957 20.9436C21.3815 21.1797 21.1554 21.3943 20.9162 21.5856C20.537 21.8891 20.1283 22.1318 19.6865 22.3131C18.9922 22.6021 18.2445 22.75 17.45 22.75C16.3114 22.75 15.1213 22.4821 13.896 21.96C12.6885 21.4455 11.4895 20.7561 10.3086 19.8963L10.3076 19.8956C9.12671 19.0331 8.00824 18.0786 6.94224 17.0229L6.93709 17.0178C5.88147 15.9519 4.92677 14.8332 4.07368 13.6614L4.07114 13.658C3.22474 12.4813 2.5351 11.293 2.0297 10.1032L2.02877 10.101C1.51719 8.88605 1.25 7.69701 1.25 6.54C1.25 5.77184 1.3856 5.02732 1.66286 4.33342C1.94487 3.61753 2.38783 2.96904 2.98958 2.39989Z"
                                                                  fill="rgba(var(--vs-danger),1)"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div
                                                class="button-method-micro flex items-center justify-center cursor-pointer"
                                                v-if="statusCall === 3">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                                     viewBox="0 0 24 24" fill="none" v-if="!isMuted"
                                                     @click="microOnOff">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M14.75 7.33303V11.222C14.7728 12.4877 13.7657 13.5325 12.5 13.556C11.2343 13.5325 10.2271 12.4877 10.25 11.222V7.33303C10.2277 6.06772 11.2347 5.02357 12.5 5.00003C13.7653 5.02357 14.7723 6.06772 14.75 7.33303Z"
                                                          stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                                                          stroke-linejoin="round"/>
                                                    <path
                                                        d="M8.46233 13.8534C8.13618 13.5981 7.66478 13.6555 7.40945 13.9817C7.15411 14.3078 7.21152 14.7792 7.53767 15.0346L8.46233 13.8534ZM17.4623 15.0346C17.7885 14.7792 17.8459 14.3078 17.5906 13.9817C17.3352 13.6555 16.8638 13.5981 16.5377 13.8534L17.4623 15.0346ZM13.25 16C13.25 15.5858 12.9142 15.25 12.5 15.25C12.0858 15.25 11.75 15.5858 11.75 16H13.25ZM11.75 19C11.75 19.4142 12.0858 19.75 12.5 19.75C12.9142 19.75 13.25 19.4142 13.25 19H11.75ZM7.53767 15.0346C10.4524 17.3164 14.5476 17.3164 17.4623 15.0346L16.5377 13.8534C14.1661 15.7101 10.8339 15.7101 8.46233 13.8534L7.53767 15.0346ZM11.75 16V19H13.25V16H11.75Z"
                                                        fill="#ffffff"/>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                                     viewBox="0 0 24 24" fill="none" v-if="isMuted" @click="microOnOff">
                                                    <path
                                                        d="M8.46233 13.8534C8.13618 13.5981 7.66478 13.6555 7.40945 13.9817C7.15411 14.3078 7.21152 14.7792 7.53767 15.0346L8.46233 13.8534ZM17.4623 15.0346C17.7885 14.7792 17.8459 14.3078 17.5906 13.9817C17.3352 13.6555 16.8638 13.5981 16.5377 13.8534L17.4623 15.0346ZM13.25 16C13.25 15.5858 12.9142 15.25 12.5 15.25C12.0858 15.25 11.75 15.5858 11.75 16H13.25ZM11.75 19C11.75 19.4142 12.0858 19.75 12.5 19.75C12.9142 19.75 13.25 19.4142 13.25 19H11.75ZM19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L19.5303 5.53033ZM10.4897 12.4497C10.1968 12.7426 10.1968 13.2174 10.4897 13.5103C10.7826 13.8032 11.2574 13.8032 11.5503 13.5103L10.4897 12.4497ZM4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L4.46967 18.4697ZM11.5503 13.5103C11.8432 13.2174 11.8432 12.7426 11.5503 12.4497C11.2574 12.1568 10.7826 12.1568 10.4897 12.4497L11.5503 13.5103ZM11.526 12.4264C11.2202 12.1469 10.7458 12.1683 10.4664 12.474C10.1869 12.7798 10.2083 13.2542 10.514 13.5336L11.526 12.4264ZM12.5 13.556L12.4986 14.306C12.5037 14.306 12.5088 14.306 12.5139 14.3059L12.5 13.556ZM14.75 11.222H13.9999L14.0001 11.2355L14.75 11.222ZM15.5 9.25C15.5 8.83579 15.1642 8.5 14.75 8.5C14.3358 8.5 14 8.83579 14 9.25H15.5ZM9.5 10.274C9.5 10.6882 9.83579 11.024 10.25 11.024C10.6642 11.024 11 10.6882 11 10.274H9.5ZM10.25 7.334L11.0001 7.334L10.9999 7.32046L10.25 7.334ZM12.5 5L12.5057 4.25002C12.4991 4.24997 12.4926 4.25001 12.4861 4.25013L12.5 5ZM13.8253 6.59048C14.0061 6.96312 14.4548 7.11859 14.8275 6.93773C15.2001 6.75687 15.3556 6.30817 15.1747 5.93552L13.8253 6.59048ZM7.53767 15.0346C10.4524 17.3164 14.5476 17.3164 17.4623 15.0346L16.5377 13.8534C14.1661 15.7101 10.8339 15.7101 8.46233 13.8534L7.53767 15.0346ZM11.75 16V19H13.25V16H11.75ZM18.4697 4.46967L10.4897 12.4497L11.5503 13.5103L19.5303 5.53033L18.4697 4.46967ZM5.53033 19.5303L11.5503 13.5103L10.4897 12.4497L4.46967 18.4697L5.53033 19.5303ZM10.514 13.5336C11.0563 14.0292 11.764 14.3046 12.4986 14.306L12.5014 12.806C12.1403 12.8053 11.7925 12.67 11.526 12.4264L10.514 13.5336ZM12.5139 14.3059C14.1936 14.2746 15.5302 12.8882 15.4999 11.2085L14.0001 11.2355C14.0155 12.0873 13.3378 12.7903 12.4861 12.8061L12.5139 14.3059ZM15.5 11.222L15.5 9.25H14V11.222H15.5ZM11 10.274V7.334H9.5V10.274H11ZM10.9999 7.32046C10.9845 6.46875 11.6622 5.76571 12.5139 5.74987L12.4861 4.25013C10.8064 4.28136 9.46979 5.66785 9.50012 7.34754L10.9999 7.32046ZM12.4943 5.74998C13.0617 5.75428 13.5775 6.08003 13.8253 6.59048L15.1747 5.93552C14.6779 4.91189 13.6435 4.25864 12.5057 4.25002L12.4943 5.74998Z"
                                                        fill="#ffffff"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="vx-col w-full px-6 pb-2"
                                             v-if="receiversInfo && (statusCall === 3 || statusCall === 4)">
                                            <vs-checkbox class="float-right" color="success" v-model="isBookingCustomer"
                                                         :disabled="statusCall === 4">
                                                <span class="text-white">Đặt lịch</span>
                                            </vs-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <VuePerfectScrollbar ref="mainSidebarPs"
                                                     class="scroll-area--nofications-dropdown p-0 mb-10"
                                                     :settings="settings" :key="$vs.rtl"
                                                     v-if="receiversInfo && isBookingCustomer && (statusCall === 3 || statusCall === 4) && isAcceptCall">
                                    <div class="create-booking-in-call p-4">
                                        <h4>Thông tin đặt lịch</h4>
                                        <div class="vx-row">
                                            <div class="vx-col w-full mt-4">
                                                <label class="vs-input--label required">Chi nhánh</label>
                                                <v-select v-model="selectedBranchCreate"
                                                          :options="branchCreateOptions"
                                                          :clearable="false"
                                                          v-validate="'required'" name="branch">
                                                    <span slot="no-options"> {{
                                                            $t('menuOrganization.noOption')
                                                        }}</span>
                                                </v-select>
                                                <span class="text-danger text-sm">{{
                                                        errors.first('branch')
                                                    }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-6">
                                                <vs-radio v-model="packageType" vs-value="1" class="mr-4"
                                                          @change="changeSelectType">Nhóm dịch vụ
                                                </vs-radio>
                                                <vs-radio v-model="packageType" vs-value="2"
                                                          @change="changeSelectType">Gói dịch vụ
                                                </vs-radio>
                                            </div>
                                            <div class="vx-col w-full mt-4" v-if="packageType == 1">
                                                <div class="vx-row">
                                                    <div class="vx-col w-full">
                                                        <label class="vs-input--label required">Nhóm dịch
                                                            vụ</label>
                                                        <v-select v-model="selectBeautyService"
                                                                  :options="beautyServiceData"
                                                                  :clearable="false"
                                                                  v-validate="''" name="nameServiceType">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                        </v-select>
                                                    </div>
                                                    <div class="vx-col w-full mt-4">
                                                        <label class="vs-input--label required">Dịch vụ</label>
                                                        <v-select v-model="selectBeautyServicePackage"
                                                                  :options="beautyServicePackageOptions"
                                                                  :clearable="false" v-validate="''"
                                                                  name="nameServicePacks">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                        </v-select>
                                                    </div>
                                                    <div class="vx-col w-full mt-4">
                                                        <label class="vs-input--label">Bác sĩ</label>
                                                        <v-select class="w-full" v-model="selectedDoctorCreate"
                                                                  :options="doctorCreateOptions"
                                                                  :clearable="false" v-validate="''"
                                                                  name="doctor">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                        </v-select>
                                                        <span class="text-danger text-sm">{{
                                                                errors.first('doctor')
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col w-full mt-4" v-if="packageType == 2">
                                                <div class="vx-row">
                                                    <div class="vx-col w-full">
                                                        <label class="vs-input--label required">Gói dịch
                                                            vụ</label>
                                                        <v-select v-model="selectedComboService"
                                                                  :options="beautyComboService"
                                                                  :clearable="false"
                                                                  v-validate="''" name="comboService">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col md:w-1/4 w-1/2 mt-4">
                                                <label class="vs-input--label">Ngày</label>
                                                <div class="w-full">
                                                    <datepicker :highlighted="highlighted" class="w-full"
                                                                :language="vi"
                                                                :format="'dd/MM/yyyy'" v-model="selectDate"
                                                                data-vv-validate-on="input"
                                                                ref="datepickBooking"
                                                                v-validate="'required'"
                                                                name="time">
                                                    </datepicker>
                                                    <span class="text-danger text-sm">{{
                                                            errors.first('time')
                                                        }}</span>
                                                </div>
                                            </div>
                                            <div class="vx-col md:w-1/4 w-1/2 mt-4">
                                                <label class="vs-input--label">Giờ</label>
                                                <div class="w-full">
&lt;!&ndash;                                                    <flat-pickr :config="configTimePicker" v-model="selectTime"&ndash;&gt;
&lt;!&ndash;                                                                class="w-full vs-inputx vs-input&#45;&#45;input normal"&ndash;&gt;
&lt;!&ndash;                                                                name="time"/>&ndash;&gt;
                                                    <vs-input name="startTime" type="time" class="w-full"
                                                              v-model="selectTime"></vs-input>
                                                </div>
                                            </div>
                                            <div class="vx-col w-full" v-if="statusCall === 4">
                                                <div class="flex float-right">
                                                    <vs-button color="primary" @click="saveBooking"
                                                               :disabled="!validateForm">
                                                        Lưu
                                                    </vs-button>
                                                    <vs-button color="danger" type="border" class="ml-4"
                                                               @click="turnOffCall">Đóng
                                                    </vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </VuePerfectScrollbar>
                                <VuePerfectScrollbar ref="mainSidebarPs"
                                                     class="scroll-area--nofications-dropdown p-0 mb-10"
                                                     :settings="settings" :key="$vs.rtl"
                                                     v-if="!receiversInfo && (statusCall === 3 || statusCall === 4) && isAcceptCall">
                                    <div class="create-customer-in-call p-4">
                                        <h4>Thông tin khách hàng</h4>
                                        <div class="vx-row">
                                            <div class="vx-col w-full mt-4" v-if="!isBookingUnknown">
                                                <label class="vs-input--label required">Chi nhánh</label>
                                                <v-select v-model="customerInfo.organizationBranchId"
                                                          :options="branchCreateOptions"
                                                          :clearable="false" :reduce="item => item.value"
                                                          v-validate="'required'" name="branchId">
                                                    <span slot="no-options"> {{
                                                            $t('menuOrganization.noOption')
                                                        }}</span>
                                                </v-select>
                                                <span class="text-danger text-sm">{{
                                                        errors.first('branch')
                                                    }}</span>
                                            </div>
                                            <div class="vx-col lg:w-1/2 w-full mt-4">
                                                <label class="vs-input--label required">Họ và tên</label>
                                                <vs-input class="w-full" v-model="customerInfo.fullName"
                                                          v-validate="'required'" name="fullName"></vs-input>
                                                <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                                            </div>
                                            <div class="vx-col lg:w-1/2 w-full mt-4">
                                                <label class="vs-input--label required">Số điện thoại</label>
                                                <vs-input class="w-full" v-model="customerInfo.phoneNumber"
                                                          name="phoneNumber"
                                                          v-validate="{regex: /(0[3|5|7|8|9])+([0-9]{8})\b/, numeric: true, required: true}"></vs-input>
                                                <span class="text-danger text-sm">{{
                                                        errors.first('phoneNumber')
                                                    }}</span>
                                            </div>
                                            <div class="vx-col lg:w-1/2 w-full mt-4">
                                                <label class="vs-input--label required">{{
                                                        $t('menuCustomer.gender')
                                                    }}</label>
                                                <v-select class="w-full" v-model="customerInfo.gender"
                                                          :options="genderOptions" name="gender"
                                                          :reduce="item => item.value" v-validate="'required'"
                                                          :clearable="false"></v-select>
                                                <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                                            </div>
                                            <div class="vx-col lg:w-1/2 w-full mt-4">
                                                <label class="vs-input--label required">Nguồn khách hàng</label>
                                                <v-select class="w-full"
                                                          v-model="customerInfo.sourceType"
                                                          :options="sourceCustomerOptions" name="sourceType"
                                                          :reduce="item => item.value" v-validate="'required'"
                                                          :clearable="false"></v-select>
                                                <span class="text-danger text-sm">{{
                                                        errors.first('sourceType')
                                                    }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-4">
                                                <label class="vs-input--label required">Địa chỉ</label>
                                                <vs-input class="w-full" v-model="customerInfo.fullAddress"
                                                          v-validate="'required'" name="fullAddress"></vs-input>
                                                <span class="text-danger text-sm">{{
                                                        errors.first('fullAddress')
                                                    }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-4">
                                                <label class="vs-input--label">Ghi chú</label>
                                                <vs-textarea class="w-full" v-model="customerInfo.callNote"
                                                             name="callNote"></vs-textarea>
                                            </div>
                                            <div class="vx-col w-full">
                                                <vs-checkbox v-model="isBookingUnknown">Đặt lịch hẹn</vs-checkbox>
                                            </div>
                                            <div class="vx-col w-full mt-8" v-if="isBookingUnknown">
                                                <div class="vx-row">
                                                    <div class="vx-col w-full">
                                                        <h4>Thông tin đặt lịch</h4>
                                                    </div>
                                                    <div class="vx-col w-full mt-4">
                                                        <label class="vs-input--label required">Chi nhánh</label>
                                                        <v-select v-model="selectedBranchCreate"
                                                                  :options="branchCreateOptions"
                                                                  :clearable="false"
                                                                  v-validate="'required'" name="branch">
                                                    <span slot="no-options"> {{
                                                            $t('menuOrganization.noOption')
                                                        }}</span>
                                                        </v-select>
                                                        <span class="text-danger text-sm">{{
                                                                errors.first('branch')
                                                            }}</span>
                                                    </div>
                                                    <div class="vx-col w-full mt-6">
                                                        <vs-radio v-model="packageType" vs-value="1" class="mr-4"
                                                                  @change="changeSelectType">Nhóm dịch vụ
                                                        </vs-radio>
                                                        <vs-radio v-model="packageType" vs-value="2"
                                                                  @change="changeSelectType">Gói dịch vụ
                                                        </vs-radio>
                                                    </div>
                                                    <div class="vx-col w-full mt-4" v-if="packageType == 1">
                                                        <div class="vx-row">
                                                            <div class="vx-col w-full">
                                                                <label class="vs-input--label required">Nhóm dịch
                                                                    vụ</label>
                                                                <v-select v-model="selectBeautyService"
                                                                          :options="beautyServiceData"
                                                                          :clearable="false"
                                                                          v-validate="''" name="nameServiceType">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                                </v-select>
                                                            </div>
                                                            <div class="vx-col w-full mt-4">
                                                                <label class="vs-input--label required">Dịch vụ</label>
                                                                <v-select v-model="selectBeautyServicePackage"
                                                                          :options="beautyServicePackageOptions"
                                                                          :clearable="false" v-validate="''"
                                                                          name="nameServicePacks">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                                </v-select>
                                                            </div>
                                                            <div class="vx-col w-full mt-4">
                                                                <label class="vs-input--label">Bác sĩ</label>
                                                                <v-select class="w-full" v-model="selectedDoctorCreate"
                                                                          :options="doctorCreateOptions"
                                                                          :clearable="false" v-validate="''"
                                                                          name="doctor">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                                </v-select>
                                                                <span class="text-danger text-sm">{{
                                                                        errors.first('doctor')
                                                                    }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col w-full mt-4" v-if="packageType == 2">
                                                        <div class="vx-row">
                                                            <div class="vx-col w-full">
                                                                <label class="vs-input--label required">Gói dịch
                                                                    vụ</label>
                                                                <v-select v-model="selectedComboService"
                                                                          :options="beautyComboService"
                                                                          :clearable="false"
                                                                          v-validate="''" name="comboService">
                                                            <span slot="no-options"> {{
                                                                    $t('menuOrganization.noOption')
                                                                }}</span>
                                                                </v-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                                                        <label class="vs-input--label">Ngày</label>
                                                        <div class="w-full">
                                                            <datepicker :highlighted="highlighted" class="w-full"
                                                                        :language="vi"
                                                                        :format="'dd/MM/yyyy'" v-model="selectDate"
                                                                        data-vv-validate-on="input"
                                                                        ref="datepickBooking"
                                                                        v-validate="'required'"
                                                                        name="time">
                                                            </datepicker>
                                                            <span class="text-danger text-sm">{{
                                                                    errors.first('time')
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                                                        <label class="vs-input--label">Giờ</label>
                                                        <div class="w-full">
&lt;!&ndash;                                                            <flat-pickr :config="configTimePicker" v-model="selectTime"&ndash;&gt;
&lt;!&ndash;                                                                        class="w-full vs-inputx vs-input&#45;&#45;input normal"&ndash;&gt;
&lt;!&ndash;                                                                        name="time"/>&ndash;&gt;
                                                            <vs-input name="startTime" type="time" class="w-full"
                                                                      v-model="selectTime"></vs-input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col w-full mt-2" v-if="statusCall === 4">
                                                <div class="flex float-right">
                                                    <vs-button color="primary" @click="saveCall"
                                                               :disabled="!validateForm">
                                                        Lưu
                                                    </vs-button>
                                                    <vs-button color="danger" type="border" class="ml-4"
                                                               @click="turnOffCall">Đóng
                                                    </vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </VuePerfectScrollbar>
                            </div>
                        </vs-popup>-->

                        <!--            <transition :name="routerTransition">-->
                        <!--              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">-->
                        <!--                <div-->
                        <!--                  class="content-area__heading"-->
                        <!--                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">-->
                        <!--                  <h2 class="mb-1">{{ routeTitle }}</h2>-->
                        <!--                </div>-->

                        <!--                &lt;!&ndash; BREADCRUMB &ndash;&gt;-->
                        <!--                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />-->

                        <!--              </div>-->
                        <!--            </transition>-->

                        <div class="content-area__content">

                            <!--                            <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"-->
                            <!--                                visibleoffset="500" v-if="!hideScrollToTop">-->
                            <!--                                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />-->
                            <!--                            </back-to-top>-->

                            <transition :name="routerTransition" mode="out-in">
                                <router-view @changeRouteTitle="changeRouteTitle"
                                             @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"/>
                            </transition>
                        </div>

                        <div id="bubble_dial" @click="showDial" v-if="isPermissionCall">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="24px" height="24px"
                                 viewBox="0 0 20 20">
                                <path
                                    d="M6 0H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm5 0H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm5 0h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM6 5H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm5 0H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm5 0h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM6 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm5 0H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm0 6H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm5-6h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <!--      <vue-particles-->
            <!--        color="#dedede"-->
            <!--        :particleOpacity="0.7"-->
            <!--        :particlesNumber="80"-->
            <!--        shapeType="circle"-->
            <!--        :particleSize="4"-->
            <!--        linesColor="#ffffff"-->
            <!--        :linesWidth="1"-->
            <!--        :lineLinked="true"-->
            <!--        :lineOpacity="0.4"-->
            <!--        :linesDistance="150"-->
            <!--        :moveSpeed="3"-->
            <!--        :hoverEffect="true"-->
            <!--        hoverMode="grab"-->
            <!--        :clickEffect="true"-->
            <!--        clickMode="push"-->
            <!--      >-->
            <!--      </vue-particles>-->
            <!-- Navbar -->

            <!-- <the-footer />-->
        </div>
        <CallScreen/>
    </div>
</template>


<script>
import BackToTop from 'vue-backtotop'
import HNavMenu from "../../layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems from "../../layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '../../layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '../../layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '../../layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '../../layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CallScreen from "@/components/CallScreen";

export default {
    components: {
        BackToTop,
        HNavMenu,
        TheFooter,
        TheNavbarHorizontal,
        TheNavbarVertical,
        VNavMenu,
        vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar,
        CallScreen
    },
    data() {
        return {
            footerType: themeConfig.footerType || 'static',
            hideScrollToTop: themeConfig.hideScrollToTop,
            isNavbarDark: false,
            navbarColor: themeConfig.navbarColor || '#fff',
            navbarType: themeConfig.navbarType || 'floating',
            navMenuItems: navMenuItems,
            routerTransition: themeConfig.routerTransition || 'none',
            routeTitle: this.$route.meta.pageTitle,
            isShowScreen: false,
            statusCall: null,
            imgCustomer: null,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            client: null,
            receiversInfo: null,
            isMuted: false,
            detailsCall: null,
            statusAnswer: null,
            startTime: null,
            endTime: null,
            receiversImage: null,
            timeString: null,
            seconds: 0,
            showDialpad: true,
            customerInfo: {
                fullName: null,
                phoneNumber: null,
                gender: null,
                fullAddress: null,
                sourceType: null,
                callNote: null,
                organizationBranchId: null,
            },
            genderOptions: [
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            sourceCustomerOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn nhân sự'},
                {value: 4, label: 'Nguồn khác'},
            ],
            isBookingUnknown: false,
            branchCreateOptions: [],
            selectedBranchCreateValue: null,
            packageType: 1,
            beautyComboService: [],
            selectedComboServiceValue: null,
            beautyServiceData: [],
            selectBeautyServiceValue: null,
            beautyServicePackageOptions: [],
            selectBeautyServicePackageValue: null,
            selectedDoctorCreateValue: null,
            doctorCreateOptions: [],
            en: en,
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            selectDate: new Date(),
            selectTime: `${new Date().getHours() + ':' + new Date().getMinutes()}`,
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            isBookingCustomer: false,
            isIncomingCall: false,
            isAcceptCall: false,
        }
    },
    watch: {
        "$route"() {
            this.routeTitle = this.$route.meta.pageTitle
        },
        isThemeDark(val) {
            const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
            this.updateNavbarColor(color)
        },
        "$store.state.mainLayoutType"(val) {
            this.setNavMenuVisibility(val)
        }
    },
    computed: {
        bodyOverlay() {
            return this.$store.state.bodyOverlay
        },
        contentAreaClass() {
            if (this.mainLayoutType === "vertical") {
                if (this.verticalNavMenuWidth == "default") return "content-area-reduced"
                else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
                else return "content-area-full"
            }
            // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
            else return "content-area-full"
        },
        footerClasses() {
            return {
                'footer-hidden': this.footerType == 'hidden',
                'footer-sticky': this.footerType == 'sticky',
                'footer-static': this.footerType == 'static',
            }
        },
        isAppPage() {
            return this.$route.meta.no_scroll
        },
        isThemeDark() {
            return this.$store.state.theme == 'dark'
        },
        layoutTypeClass() {
            return `main-${this.mainLayoutType}`
        },
        mainLayoutType() {
            return this.$store.state.mainLayoutType
        },
        navbarClasses() {
            return {
                'navbar-hidden': this.navbarType == 'hidden',
                'navbar-sticky': this.navbarType == 'sticky',
                'navbar-static': this.navbarType == 'static',
                'navbar-floating': this.navbarType == 'floating',
            }
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },
        isPermissionCall() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let space = localStorage.getItem('work_space');
            let isChat = JSON.parse(localStorage.getItem('isChat'));
            if (userInfo.userRole == 'user' && space == 'crm' && !isChat) {
                let permission = JSON.parse(localStorage.getItem('permissions'))
                let result = permission.find(el => el.functionName == 'PRIVILEGE_VBOT_CUSTOMER_CALL');
                if (result) return true;
                return false
            } else {
                return false;
            }
        },
        selectedBranchCreate: {
            get() {
                let obj = this.branchCreateOptions.find(x => x.value === this.selectedBranchCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedBranchCreateValue = obj ? obj.value : null;
                this.selectBeautyServiceValue = null;
                this.selectBeautyServicePackageValue = null;
                this.selectedComboServiceValue = null;
                this.beautyServicePackageOptions = [];
                this.beautyServiceData = [];
                this.beautyComboService = [];
                if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
                if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
                this.doctorCreateOptions = [];
                await this.$validator.reset();
            }
        },
        selectBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },
        selectBeautyServicePackage: {
            get() {
                let obj = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServicePackageValue = obj ? obj.value : null;
                this.selectedDepartmentCreateValue = obj ? obj.departmentId : null;
                this.getDoctor(false);
            }
        },
        selectedDoctorCreate: {
            get() {
                let obj = this.doctorCreateOptions.find(x => x.value === this.selectedDoctorCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorCreateValue = obj ? obj.value : null;
            }
        },
        selectedComboService: {
            get() {
                let obj = this.beautyComboService.find(x => x.value === this.selectedComboServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedComboServiceValue = obj ? obj.value : null;
            }
        },
        validateForm() {
            return !this.errors.any();
        },
    },
    methods: {
        changeRouteTitle(title) {
            this.routeTitle = title
        },
        updateNavbar(val) {
            if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
            this.navbarType = val
        },
        updateNavbarColor(val) {
            this.navbarColor = val
            if (val == "#fff") this.isNavbarDark = false
            else this.isNavbarDark = true
        },
        updateFooter(val) {
            this.footerType = val
        },
        setNavMenuVisibility(layoutType) {
            if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
            } else {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
            }
        },
        toggleHideScrollToTop(val) {
            this.hideScrollToTop = val
        },
        // async connectServerCall() {
        //     let tokenCall = localStorage.getItem('tokenCall');
        //     this.$vs.loading();
        //     this.client = await VBotClient(tokenCall);
        //     this.awaitIncomingCall();
        //     this.client.connect();
        // },
        // async callCustomer() {
        //     this.$vs.loading();
        //     this.startTime = null;
        //     this.endTime = null;
        //     let hotlines = await this.client.getHotlines(),
        //         randomInd = Math.floor(Math.random() * hotlines.length),
        //         hotlinesNumber = hotlines[randomInd].phoneNumber;
        //     // Khoi tao cuoc goi
        //     // let phoneNumber = '0866683056'
        //     let phoneNumber = this.receiversInfo.phoneNumber;
        //     await this.startCall(phoneNumber, hotlinesNumber);
        // },
        //
        // async cancelCall() {
        //     if (this.statusCall === 1 && !this.isIncomingCall) {
        //         this.statusAnswer = 4;
        //         await this.sessionCall.cancel();
        //     }
        //     if (this.statusCall === 1 && this.isIncomingCall) await this.sessionCall.reject();
        //     if (this.statusCall === 3) await this.sessionCall.terminate();
        //     this.statusCall = 4;
        // },
        // microOnOff() {
        //     this.sessionCall.media.input.muted = !this.sessionCall.media.input.muted;
        //     this.isMuted = !this.isMuted;
        // },
        // beginCall(phone) {
        //     return new Promise((resolve, reject) => {
        //         let payload = {
        //             callType: 1,
        //             calleeIds: this.receiversInfo ? [this.receiversInfo.id] : null,
        //             callerId: this.userInfo.employeeId,
        //             channel: 'VBOT',
        //             status: 1,
        //             phoneNumber: phone,
        //         }
        //
        //         this.$crm.post('/ott/call-history/begin-call', payload).then(res => {
        //             this.detailsCall = res.data;
        //             resolve(res)
        //         }).catch((err) => {
        //             reject(err)
        //             this.$vs.notify({
        //                 title: 'Error',
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        // endCall() {
        //     let payload = {
        //         callType: 1,
        //         calleeIds: this.receiversInfo ? [this.receiversInfo.id] : null,
        //         callerId: this.userInfo.employeeId,
        //         startTime: this.startTime,
        //         endTime: this.endTime,
        //         id: this.detailsCall.id,
        //         channel: 'VBOT',
        //         status: this.statusAnswer,
        //     }
        //
        //     this.$crm.post('/ott/call-history/change-call-status', payload).then().catch((err) => {
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     });
        // },
        // checkMicro() {
        //     return new Promise((resolve, reject) => {
        //         if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        //             // Try to get access to the microphone
        //             navigator.mediaDevices.getUserMedia({audio: true}).then(function (stream) {
        //                 // Microphone is available and access is granted
        //                 console.log('Microphone is available and access is granted');
        //                 // You can stop the stream if you don't need it
        //                 stream.getTracks().forEach(track => track.stop());
        //                 resolve()
        //             }).catch(() => {
        //                 reject()
        //                 // Microphone access denied or unavailable
        //                 return this.$vs.notify({
        //                     text: 'Micro không khả dụng!',
        //                     iconPack: 'feather',
        //                     icon: 'icon-alert-circle',
        //                     color: 'danger'
        //                 });
        //             });
        //         } else {
        //             // Web Audio API not supported
        //             return this.$vs.notify({
        //                 text: 'Không hỗ trợ trên trình duyệt này!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         }
        //     })
        // },
        // stopwatchCall() {
        //     this.seconds++;
        //     const hours = Math.floor(this.seconds / 3600);
        //     const minutes = Math.floor((this.seconds % 3600) / 60);
        //     const sec = this.seconds % 60;
        //     this.timeString = (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":" + (sec < 10 ? "0" : "") + sec;
        // },
        async showDial() {
            this.$eventBus.$emit("beauty-show-dial", true);
            // this.showDialpad = !this.showDialpad
            // this.client.showDialpad(this.showDialpad);
            // if (!this.showDialpad) {
            //     let that = this;
            //     document.getElementById('vbot-call-btn').addEventListener('click',
            //         this.client.on("numberFromDialpad", async function (phoneNumber, hotline) {
            //             await that.checkMicro();
            //             await that.findCustomerByPhone(phoneNumber);
            //             await that.startCall(phoneNumber, hotline);
            //         })
            //     )
            //     ;
            // }
        },
        // async startCall(phoneNumber, hotline) {
        //     try {
        //         this.sessionCall = await this.client.invite(phoneNumber, hotline).catch(console.error);
        //         this.$vs.loading.close();
        //         await this.beginCall(phoneNumber);
        //         if (!this.sessionCall) {
        //             this.receiversInfo = null
        //             this.isIncomingCall = false;
        //             this.endCall();
        //             return this.$vs.notify({
        //                 text: 'Lỗi cuộc gọi!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         }
        //         //
        //         // // show progress dang thuc hien cuoc goi
        //         this.isShowScreen = true;
        //         this.statusCall = 1;
        //         let callParent = document.getElementById('popup-call');
        //         if (callParent) {
        //             let backgroundCall = callParent.querySelector('.vs-popup--background');
        //             if (backgroundCall) callParent.removeChild(backgroundCall);
        //         }
        //
        //         let {accepted, rejectCause} = await this.sessionCall.accepted(); // wait until the call is picked up
        //         if (!accepted) {
        //             // show nguyen nhan cuoc goi bi rejected
        //             this.statusCall = 2;
        //             this.statusAnswer = this.statusAnswer === 4 ? 4 : 3;
        //             this.receiversInfo = null
        //             this.isIncomingCall = false;
        //             this.endCall();
        //             this.statusAnswer = null;
        //             setTimeout(() => {
        //                 this.isShowScreen = false;
        //             }, 1500)
        //             return;
        //         }
        //         // show man hinh cuoc goi
        //         if (!this.showDialpad) {
        //             this.showDialpad = !this.showDialpad
        //             this.client.showDialpad(this.showDialpad);
        //         }
        //
        //         this.statusCall = 3;
        //         this.isAcceptCall = true;
        //         this.statusAnswer = 200;
        //         this.startTime = new Date();
        //         let intervalId = setInterval(this.stopwatchCall, 1000);
        //
        //         // cuoc goi ket thuc
        //         // wait until the call is terminated
        //         await this.sessionCall.terminated();
        //         this.endTime = new Date();
        //         clearInterval(intervalId);
        //         this.endCall();
        //         this.isIncomingCall = false;
        //         this.statusAnswer = null;
        //         this.statusCall = 4;
        //         if (this.receiversInfo && !this.isBookingCustomer) {
        //             setTimeout(() => {
        //                 this.turnOffCall();
        //             }, 1500);
        //         }
        //     } catch (e) {
        //         console.error(e)
        //     }
        // },
        //
        // turnOffCall() {
        //     this.isMuted = false;
        //     this.isShowScreen = false;
        //     this.statusCall = null;
        //     this.seconds = 0;
        //     this.timeString = null;
        //     this.isAcceptCall = false;
        //     this.receiversInfo = null;
        //     this.isIncomingCall = false;
        // },
        //
        // findCustomerByPhone(phone) {
        //     return new Promise((resolve, reject) => {
        //         this.$vs.loading();
        //         this.$crm.get(`/loyalty/customer/find?keySearch=${phone}`).then(res => {
        //             if (res.data.content && res.data.content.length > 0) {
        //                 this.receiversInfo = res.data.content[0];
        //                 if (this.receiversInfo.fileManagers && this.receiversInfo.fileManagers.length > 0) this.receiversImage = this.receiversInfo.fileManagers[0].url;
        //             } else {
        //                 this.receiversInfo = null;
        //                 this.receiversImage = null;
        //                 this.customerInfo.phoneNumber = phone;
        //             }
        //             resolve(res)
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             reject(err);
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        // async changeSelectType() {
        //     this.selectBeautyServiceValue = null;
        //     this.selectBeautyServicePackageValue = null;
        //     this.selectedDoctorCreateValue = null;
        //     this.selectedDepartmentCreateValue = null;
        //     this.selectBeautyServicePackageValue = null;
        //     this.selectedComboServiceValue = null;
        //
        //     if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
        //     if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
        // },
        // getBeautyService(dataService) {
        //     return new Promise((resolve, reject) => {
        //         this.beautyServiceData = [];
        //         let payload = {
        //             organizationBranchId: this.selectedBranchCreateValue,
        //             keySearch: dataService ? dataService.beautyService.name : null,
        //         }
        //         this.$vs.loading();
        //         this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
        //             res.data.content.map(x => {
        //                 let data = this.beautyServiceData.find(t => t.value == x.id);
        //                 if (!data) {
        //                     let result = {
        //                         value: x.id,
        //                         label: x.code + '-' + x.name,
        //                     }
        //                     this.beautyServiceData.push(result);
        //                 }
        //             })
        //             this.beautyServiceData = Array.from(new Set(this.beautyServiceData));
        //             resolve()
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             reject();
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        // getBeautyServicePack() {
        //     return new Promise((resolve, reject) => {
        //         this.$vs.loading();
        //         let payload = {
        //             organizationBranchId: this.selectedBranchCreateValue,
        //             beautyServiceId: this.selectBeautyServiceValue,
        //         };
        //         this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
        //             this.beautyServicePackageOptions = res.data.content.map(el => {
        //                 return {
        //                     value: el.beautyServicePackage.id,
        //                     label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
        //                     departmentId: el.beautyServicePackage.departmentId,
        //                 }
        //             })
        //             resolve();
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             reject();
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        // getBeautyComboService() {
        //     return new Promise((resolve, reject) => {
        //         this.$vs.loading();
        //         this.$crm.post('/beauty-package-combo/find-by-condition', {organizationBranchId: this.selectedBranchCreateValue}).then(res => {
        //             if (res.data.content && res.data.content.length > 0) {
        //                 this.beautyComboService = res.data.content.map(x => {
        //                     return {
        //                         label: x.code + '-' + x.name,
        //                         value: x.id
        //                     };
        //                 });
        //             }
        //             resolve();
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             reject();
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        // getDoctor(check) {
        //     return new Promise((resolve, reject) => {
        //         let url = '/beauty-booking/get-list-doctor-department';
        //
        //         this.doctorCreateOptions = [];
        //         if (this.selectedBranchCreateValue) {
        //             url += '?organizationBranchId=' + this.selectedBranchCreateValue
        //         }
        //         if (this.selectedDepartmentCreateValue) {
        //             url += '&departmentId=' + this.selectedDepartmentCreateValue
        //         }
        //
        //         this.$vs.loading();
        //         this.$crm.get(url).then(res => {
        //             if (res.data.data && res.data.data.length > 0) {
        //                 this.doctorCreateOptions = res.data.data.map(el => {
        //                     return {
        //                         value: el.id,
        //                         label: el.fullName
        //                     }
        //                 });
        //             }
        //             if (check) this.doctorOptions.unshift({value: null, label: 'Tất cả'});
        //             resolve();
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             reject();
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        //
        // async saveCall(evt) {
        //     evt.preventDefault();
        //     if (!this.validateForm) return;
        //     const result = await this.$validator.validateAll();
        //     if (!result) return;
        //
        //     let payload = {
        //         fullName: this.customerInfo.fullName,
        //         phoneNumber: this.customerInfo.phoneNumber,
        //         gender: this.customerInfo.gender,
        //         fullAddress: this.customerInfo.fullAddress,
        //         loyaltyCustomerSource: this.customerInfo.sourceType,
        //         sourceCustomer: 2,
        //     };
        //
        //     if (this.isBookingUnknown) {
        //         if (this.isBookingUnknown && this.packageType == 1 && !this.selectBeautyServicePackageValue) {
        //             return this.$vs.notify({
        //                 text: 'Dịch vụ là trường bắt buộc!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         }
        //
        //         if (this.isBookingUnknown && this.packageType == 2 && !this.selectedComboServiceValue) {
        //             return this.$vs.notify({
        //                 text: 'Gói dịch vụ là trường bắt buộc!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //
        //                 color: 'danger'
        //             });
        //         }
        //         let hour = this.selectTime.substr(0, 2),
        //             minutes = this.selectTime.substr(3, 2),
        //             checkDate = new Date(new Date(this.selectDate).setHours(parseInt(hour), parseInt(minutes), 0));
        //         if (checkDate < new Date()) {
        //             return this.$vs.notify({
        //                 text: 'Thời gian đặt lịch không hợp lệ!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         }
        //
        //         payload['organizationBranchId'] = this.selectedBranchCreateValue;
        //         payload['isDoctorCreate'] = true;
        //         payload['packageType'] = this.packageType;
        //         payload['beautyBookingDetails'] = [
        //             {
        //                 beautyServicePackageId: this.selectBeautyServicePackageValue,
        //                 bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
        //                 performerId: this.selectedDoctorCreateValue,
        //                 startTime: this.selectTime,
        //                 beautyPackageComboId: this.selectedComboServiceValue,
        //                 id: this.idDetails,
        //             }
        //         ];
        //
        //         this.$vs.loading();
        //         this.$crm.post('/beauty-booking/create', payload).then(() => {
        //             this.$vs.notify({
        //                 text: `Tạo mới lịch hẹn thành công!`,
        //                 iconPack: 'feather',
        //                 icon: 'icon-check-circle',
        //                 color: 'success'
        //             })
        //             this.turnOffCall();
        //             this.$vs.loading.close();
        //         }).catch(err => {
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     } else {
        //         const formData = new FormData();
        //         const blob = new Blob([JSON.stringify(this.customerInfo)], {type: 'application/json'});
        //         formData.append('loyaltyCustomerDTO ', blob);
        //         this.$vs.loading();
        //         this.$crm.post('/loyalty/customer/create', formData).then(() => {
        //             this.$vs.notify({
        //                 color: 'success',
        //                 text: `${this.$t('menuCustomer.addCustomerSS')}`,
        //                 iconPack: 'feather',
        //                 icon: 'icon-check-circle',
        //             });
        //             this.turnOffCall();
        //             this.$vs.loading.close();
        //         }).catch((err) => {
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             })
        //         })
        //     }
        // },
        //
        // async saveBooking(evt) {
        //     evt.preventDefault();
        //     if (!this.validateForm) return;
        //     const result = await this.$validator.validateAll();
        //     if (!result) return;
        //
        //     if (this.packageType == 1 && !this.selectBeautyServicePackageValue) {
        //         return this.$vs.notify({
        //             text: 'Dịch vụ là trường bắt buộc!',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     }
        //
        //     if (this.packageType == 2 && !this.selectedComboServiceValue) {
        //         return this.$vs.notify({
        //             text: 'Gói dịch vụ là trường bắt buộc!',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //
        //             color: 'danger'
        //         });
        //     }
        //
        //     if (this.selectedStatusBeautyValue === 4 && !this.cancelReason) {
        //         return this.$vs.notify({
        //             text: 'Lý do hủy là trường bắt buộc!',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     }
        //
        //     let payload = {
        //         organizationBranchId: this.selectedBranchCreateValue,
        //         loyaltyCustomerId: this.receiversInfo.id,
        //         isDoctorCreate: true,
        //         packageType: this.packageType,
        //         sourceCustomer: 1,
        //         beautyBookingDetails: [
        //             {
        //                 beautyServicePackageId: this.selectBeautyServicePackageValue,
        //                 bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
        //                 performerId: this.selectedDoctorCreateValue,
        //                 startTime: this.selectTime,
        //                 beautyPackageComboId: this.selectedComboServiceValue,
        //             }
        //         ]
        //     }
        //     let hour = this.selectTime.substr(0, 2),
        //         minutes = this.selectTime.substr(3, 2),
        //         checkDate = new Date(new Date(this.selectDate).setHours(parseInt(hour), parseInt(minutes), 0));
        //     if (checkDate < new Date()) {
        //         return this.$vs.notify({
        //             text: 'Thời gian đặt lịch không hợp lệ!',
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     }
        //     this.$vs.loading();
        //     this.$crm.post('/beauty-booking/create', payload).then(() => {
        //         this.$vs.notify({
        //             text: `Tạo mới lịch hẹn thành công!`,
        //             iconPack: 'feather',
        //             icon: 'icon-check-circle',
        //             color: 'success'
        //         })
        //         this.turnOffCall();
        //         this.$vs.loading.close();
        //     }).catch(err => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     });
        // },
        //
        // awaitIncomingCall() {
        //     this.client.on('invite', async (session) => {
        //         try {
        //             await this.findCustomerByPhone(session.phoneNumber);
        //             await this.beginCall(session.phoneNumber);
        //             this.isIncomingCall = true;
        //             this.isShowScreen = true;
        //             this.statusCall = 1;
        //             let callParent = document.getElementById('popup-call');
        //             if (callParent) {
        //                 let backgroundCall = callParent.querySelector('.vs-popup--background');
        //                 if (backgroundCall) callParent.removeChild(backgroundCall);
        //             }
        //
        //             this.sessionCall = session;
        //             this.statusCallLog();
        //
        //             let {accepted, rejectCause} = await session.accepted();
        //             if (!accepted) {
        //                 // show nguyen nhan cuoc goi bi rejected
        //                 this.statusCall = 2;
        //                 this.statusAnswer = this.statusAnswer === 4 ? 4 : 3;
        //                 this.isIncomingCall = false;
        //                 this.endCall();
        //                 this.statusAnswer = null;
        //                 setTimeout(() => {
        //                     this.isShowScreen = false;
        //                 }, 1500)
        //                 return;
        //             }
        //             this.statusCall = 3;
        //             this.isAcceptCall = true;
        //             this.statusAnswer = 200;
        //             this.startTime = new Date();
        //             let intervalId = setInterval(this.stopwatchCall, 1000);
        //
        //             await this.sessionCall.terminated();
        //             this.endTime = new Date();
        //             clearInterval(intervalId);
        //             this.isIncomingCall = false;
        //             this.endCall();
        //             this.statusAnswer = null;
        //             this.statusCall = 4;
        //             if (this.receiversInfo && !this.isBookingCustomer) {
        //                 setTimeout(() => {
        //                     this.turnOffCall();
        //                 }, 1500);
        //             }
        //         } catch (e) {
        //             console.log(e);
        //         } finally {
        //
        //         }
        //     });
        // },
        //
        // statusCallLog() {
        //     let that = this;
        //     this.sessionCall.on("statusUpdate", async function (status) {
        //         if (status.status == "terminated" && that.statusCall === 1) {
        //             that.statusCall = 2;
        //             that.statusAnswer = that.statusAnswer === 4 ? 4 : 3;
        //             that.endCall();
        //             that.statusAnswer = null;
        //             setTimeout(() => {
        //                 that.isShowScreen = false;
        //             }, 2000)
        //         }
        //         console.log(`Trạng thái của cuộc gọi đã thay đổi thành ${status.status}`)
        //     });
        // },
        //
        // async acceptCall() {
        //     await this.checkMicro();
        //     await this.sessionCall.accept();
        // }
    },
    created() {
        const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
        this.updateNavbarColor(color)
        this.setNavMenuVisibility(this.$store.state.mainLayoutType);
        // let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        // this.branchCreateOptions = branchList.map(x => {
        //     return {label: x.organizationBranchName, value: x.id}
        // });
        // if (this.userInfo.userRole == 'user') {
        //     let permission = JSON.parse(localStorage.getItem('permissions'));
        //     let result = permission.find(el => el.functionName == 'PRIVILEGE_VBOT_CUSTOMER_CALL');
        //     if (result) {
        //         let tokenCall = localStorage.getItem('tokenCall');
        //         if (!tokenCall) {
        //             return this.$vs.notify({
        //                 text: 'Không tồn tại token call!',
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         } else {
        //             this.connectServerCall();
        //         }
        //     }
        // }
    },

    // mounted() {
    //     this.$eventBus.$on("beauty-call", async ($event) => {
    //         await this.checkMicro();
    //         this.receiversInfo = $event;
    //         if (this.receiversInfo.fileManagers && this.receiversInfo.fileManagers.length > 0) this.receiversImage = this.receiversInfo.fileManagers[0].url;
    //         await this.callCustomer();
    //     })
    // },
    //
    // async destroyed() {
    //     if (this.isPermissionCall) {
    //         this.client.showDialpad(true);
    //         if (this.statusCall === 1) await this.sessionCall.cancel();
    //         if (this.statusCall === 3) await this.sessionCall.terminate();
    //     }
    // }
}

</script>
<style scoped>
/*#content-area{*/
/*  position: relative;*/
/*  background: darkslategray;*/
/*}*/
/*.content-wrapper{*/
/*  position: relative;*/
/*  z-index: 1;*/
/*}*/
/*#particles-js{*/
/*  position: absolute;*/
/*  z-index: 0;*/
/*  left: 0;*/
/*  top: 0;*/
/*  height: 100%;*/
/*  width: 100%;*/
/*}*/
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">

#bubble_dial {
    width: 50px;
    height: 50px;
    background-color: #FFFFFF;
    z-index: 999;
    position: fixed;
    bottom: 20px;
    right: 20px;
    box-shadow: 0 3px 4px 4px rgba(0, 0, 0, .1);
    border-radius: 50%;
    text-align: center;
    padding: 15px;
    cursor: pointer;
    display: flex;
}

#bubble_dial:hover {
    svg {
        fill: rgba(var(--vs-primary), 1);
    }
}

#vbotCallContainer {
    z-index: 999;

    #vbot-call-controls {
        position: fixed !important;
        right: 75px !important;
        margin: 0 !important;
    }
}
</style>

